//统一管理地址
// export const baseUrl = "/api-proxy"; //本地开发 接口代理
// export const baseUrl = "http://localhost:8080";
//远程
  export const baseUrl_New = "http://101.132.138.207:8080";
//本地
// export const baseUrl_New = "http://localhost:8080";
// 测试环境
// export const baseUrl_New = "http://175.24.184.140:8888";
// export const baseUrl_New = "http://localhost:8888";
